import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-5 d-flex flex-column text-center text-primary"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-spinner fa-spin font-size-5xl me-2 animated slow flash infinite" }, null, -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "mt-1" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Loading...")
], -1 /* HOISTED */)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "p-3 profile-container" }
const _hoisted_7 = { class: "sub-container col-12" }
const _hoisted_8 = { class: "row g-0 col-12 ps-3 mt-3 pt-1" }
const _hoisted_9 = { class: "col-3" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "mb-1" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Name")
], -1 /* HOISTED */)
const _hoisted_11 = { class: "col-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "mb-1" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "MRN")
], -1 /* HOISTED */)
const _hoisted_13 = { id: "start-of-care" }
const _hoisted_14 = { class: "col-3 ps-5" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "mb-1" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Gender")
], -1 /* HOISTED */)
const _hoisted_16 = { id: "dnr" }
const _hoisted_17 = { class: "col-3" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", { class: "mb-1" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "DOB")
], -1 /* HOISTED */)
const _hoisted_19 = { class: "row g-0 col-12 ps-3 mt-2 pt-1" }
const _hoisted_20 = { class: "col-3" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", { class: "mb-1" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Start Of Care")
], -1 /* HOISTED */)
const _hoisted_22 = { id: "start-of-care" }
const _hoisted_23 = { class: "col-3" }
const _hoisted_24 = { class: "mb-1" }
const _hoisted_25 = { class: "col-3 ps-5" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("p", { class: "mb-1" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "DNR")
], -1 /* HOISTED */)
const _hoisted_27 = { id: "dnr" }
const _hoisted_28 = { class: "sub-container mt-2 col-12" }
const _hoisted_29 = { class: "row g-0 col-12 ps-3 mt-2 pt-1" }
const _hoisted_30 = { class: "col-12" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("p", { class: "mb-1" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Primary Diagnosis")
], -1 /* HOISTED */)
const _hoisted_32 = { class: "sub-container mt-2 col-12" }
const _hoisted_33 = { class: "row g-0 col-12 ps-3 mt-2 pt-1" }
const _hoisted_34 = { class: "col-12" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("p", { class: "mb-1" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Primary Phone")
], -1 /* HOISTED */)
const _hoisted_36 = { class: "col-4" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("p", { class: "mb-1" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Address Line 1")
], -1 /* HOISTED */)
const _hoisted_38 = { class: "col-8" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("p", { class: "mb-1" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Address Line 2")
], -1 /* HOISTED */)
const _hoisted_40 = { class: "col-4" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("p", { class: "mb-1" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "City")
], -1 /* HOISTED */)
const _hoisted_42 = { class: "col-3" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("p", { class: "mb-1" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "State")
], -1 /* HOISTED */)
const _hoisted_44 = { class: "col-2" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("p", { class: "mb-1" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Postal")
], -1 /* HOISTED */)
const _hoisted_46 = { class: "col-3" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("p", { class: "mb-1" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "County")
], -1 /* HOISTED */)
const _hoisted_48 = { class: "sub-container mt-2 col-12" }
const _hoisted_49 = { class: "row g-0 col-12 ps-3 mt-2 pt-1" }
const _hoisted_50 = { class: "col-4" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("p", { class: "mb-1" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Primary Emergency Contact")
], -1 /* HOISTED */)
const _hoisted_52 = { class: "col-5" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("p", { class: "mb-1" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Primary Emergency Phone")
], -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormSection = _resolveComponent("FormSection")!

  return (_openBlock(), _createBlock(_component_FormSection, {
    "full-height": false,
    title: _ctx.profileTitle,
    "title-class": "ps-2",
    "show-product-pill": true,
    "application-id": _ctx.application,
    "show-background": true,
    "use-gray-theme": true,
    cancel: _ctx.cancel
  }, {
    content: _withCtx(() => [
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("section", _hoisted_1, _hoisted_4))
        : _createCommentVNode("v-if", true),
      (!_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("section", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("p", null, _toDisplayString(_ctx.fullName), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _hoisted_12,
                    _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.patientDetails?.Mrn || "N/A"), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.userGender), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _hoisted_18,
                    _createElementVNode("p", null, _toDisplayString(_ctx.DOB), 1 /* TEXT */)
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _hoisted_21,
                    _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.startOfCare), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("p", _hoisted_24, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.carePeriodTitle), 1 /* TEXT */)
                    ]),
                    _createElementVNode("p", null, _toDisplayString(_ctx.carePeriod), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _hoisted_26,
                    _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.patientDetails?.IsDnr === true ? "Yes" : "No"), 1 /* TEXT */)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _hoisted_31,
                    _createElementVNode("p", null, _toDisplayString(_ctx.patientDetails?.Diagnosis || "N/A"), 1 /* TEXT */)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _hoisted_35,
                    _createElementVNode("p", null, _toDisplayString(_ctx.primaryPhone), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    _hoisted_37,
                    _createElementVNode("p", null, _toDisplayString(_ctx.patientDetails?.AddressLine1 || "N/A"), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    _hoisted_39,
                    _createElementVNode("p", null, _toDisplayString(_ctx.patientDetails?.AddressLine2 || "N/A"), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    _hoisted_41,
                    _createElementVNode("p", null, _toDisplayString(_ctx.patientDetails?.City || "N/A"), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_42, [
                    _hoisted_43,
                    _createElementVNode("p", null, _toDisplayString(_ctx.patientDetails?.State || "N/A"), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_44, [
                    _hoisted_45,
                    _createElementVNode("p", null, _toDisplayString(_ctx.patientDetails?.PostalCode ? _ctx.formatZipCode(_ctx.patientDetails.PostalCode) : "N/A"), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_46, [
                    _hoisted_47,
                    _createElementVNode("p", null, _toDisplayString(_ctx.patientDetails?.County || "N/A"), 1 /* TEXT */)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("div", _hoisted_49, [
                  _createElementVNode("div", _hoisted_50, [
                    _hoisted_51,
                    _createElementVNode("p", null, _toDisplayString(_ctx.patientDetails?.EmergencyPrimaryContactName?.trim()
                                            ? _ctx.patientDetails.EmergencyPrimaryContactName
                                            : "N/A"), 1 /* TEXT */)
                  ]),
                  _createElementVNode("div", _hoisted_52, [
                    _hoisted_53,
                    _createElementVNode("p", null, _toDisplayString(_ctx.emergencyPhone), 1 /* TEXT */)
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["title", "application-id", "cancel"]))
}